
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M52 15.7l.57 1c10.59 19.48-2.82 33.49-10 37.37-7.79 4.23-21.24 7.34-25.83-1.1s5.21-12.08 2-17.93-11.56.4-16.15-8S8 9 15.8 4.75C22.21 1.27 38.21-2 49.08 11.44","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M35.14 41.65s.91 2.65-1.92 6.36c-3.3 4.33-10 4.11-10 4.11s1.89-2.47 1.6-4.65c-.23-1.72-.59-4.36 1.3-6.83a6.51 6.51 0 014.07-2.76","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M34.611 30.77l5.805 3.912-4.779 7.09-5.805-3.912z"}}),_c('path',{attrs:{"d":"M40.38 34.66S60.71 3.34 58.29 1.71l.16.11c-2.42-1.63-23.82 29-23.82 29","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"14.38","cy":"21.13","r":"4","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"27.38","cy":"13.13","r":"4","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M44.13 17.73a4 4 0 10-4.56 5.32M36.18 41.13a6 6 0 105.77-9","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    